// Arabic UI additions. Placeholder names remain identical to the English contract.
export const arabicAdditions = {
  "packageInstall.control": "يمكنك مشاهدة هذا البرنامج بتحديث قائمة {parentalControl} ضمن {adjustment}.",
  "rentals": "المحتويات المستأجرة",
  "removeFromContinueWatching": "إزالة من متابعة المشاهدة",
  "connected": "متصل",
  "disconnected": "غير متصل",
  "nextEpisode": "الحلقة التالية",
  "skipIntro": "تخطي المقدمة",
  "skipSummary": "تخطي الملخص",
  "skipToNextEpisode": "الانتقال إلى الحلقة التالية",
  "Downloads": "التنزيلات",
  "purchaseHistoryy": "سجل الاستئجار والشراء",
  "rentPurchase": "سجل الاستئجار والشراء",
  "historySearch": "سجل البحث",
  "goTivibu": "Tivibu Go",
  "houseTivibu": "Tivibu Ev",
  "mesaage": "اكتب رسالتك",
  "logout1": "خروج",
  "signOut": "تسجيل الخروج",
  "okay": "حسنًا",
  "login.login": "تسجيل الدخول",
  "login.pin": "رمز التعريف الشخصي",
  "login.pinRequired": "رمز التعريف الشخصي مطلوب",
  "login.enterPIN": "أدخل رمز التعريف الشخصي",
  "login.forgotPasswordText": "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور.",
  "login.newPassword": "كلمة المرور الجديدة",
  "login.newPasswordAgain": "تأكيد كلمة المرور الجديدة",
  "login.resetPWSuccess": "تمت إعادة تعيين كلمة المرور بنجاح. جارٍ الانتقال إلى صفحة تسجيل الدخول.",
  "login.resetPwError": "تعذرت إعادة تعيين كلمة المرور. تحقق من المعلومات وحاول مجددًا.",
  "login.matchPasswords": "كلمتا المرور غير متطابقتين",
  "login.minPwLength": "يجب ألا تقل كلمة المرور عن 6 أحرف",
  "login.email": "البريد الإلكتروني",
  "profile.deleteConfirmText": "هل تريد حذف هذا الملف الشخصي؟",
  "profile.changesSaved": "تم حفظ التغييرات!",
  "profile.changesNotSaved": "تعذر حفظ التغييرات!",
  "profile.enterProfilePasswordToBuyRent": "يلزم رمز الملف الشخصي لشراء هذا المحتوى أو استئجاره.",
  "footer.footerText": "شاهد أفضل الأفلام والمسلسلات في أي وقت ومن أي مكان.",
  "footer.cookiePolicy": "سياسة ملفات تعريف الارتباط",
  "footer.termsOfService": "شروط الخدمة",
  "footer.privacyPolicy": "سياسة الخصوصية",
  "footer.tvShows": "البرامج التلفزيونية",
  "footer.legal": "المعلومات القانونية",
  "footer.copyright": "© {year} Saat Teknoloji. جميع الحقوق محفوظة.",
  "usePromoCode": "استخدام رمز ترويجي",
  "outOfPacket": "باقتك لا تشمل هذا المحتوى.",
  "outOfChannel": "باقتك لا تشمل هذه القناة.",
  "outOfPacketConfirm": "حسنًا",
  "arabic": "العربية",
  "moreInfo": "المزيد من المعلومات",
  "showMore": "عرض المزيد",
  "showLess": "عرض أقل",
  "currentlyBeingWatched": "قيد المشاهدة",
  "rentedOnes": "المحتويات المستأجرة",
  "noRecords": "لا توجد برامج مجدولة للتسجيل",
  "typeMessage": "اكتب رسالتك",
  "suggestion": "اقتراح",
  "shareText": "أشاهد {contentName} على Atlas وأعتقد أنه سينال إعجابك!\n",
  "complaint": "شكوى",
  "packageInstall.unlockFailed": "تعذر إلغاء قفل القناة. حاول مجددًا.",
  "userInfoIncorrect": "معلومات المستخدم غير صحيحة",
  "quicklinks": "روابط سريعة",
  "home": "الرئيسية",
  "mainLoadingText": "جارٍ التحميل. يرجى الانتظار…",
  "emptyMessageText": "لا تترك هذا الحقل فارغًا.",
  "recorded": "مسجل",
  "unavailableRecords": "غير متاح",
  "recordingCount": "التسجيلات: {used} / {limit}",
  "availableFrom": "متاح ابتداءً من",
  "publicationDatePending": "سيُعلن عن تاريخ الإصدار لاحقًا",
  "trailerUnavailable": "الإعلان التشويقي غير متاح حاليًا",
  "recordSaved": "مسجل",
  "recordingErrors.6401": "التسجيل غير مفعّل لهذه القناة.",
  "recordingErrors.6402": "هذا البرنامج موجود بالفعل في تسجيلاتك.",
  "recordingErrors.6403": "تم بلوغ حد عدد التسجيلات أو مدتها.",
  "recordingErrors.6406": "باقتك لا تسمح بتسجيل هذه القناة.",
  "recordingStatuses.ready": "مسجل",
  "recordingStatuses.scheduled": "سيتم تسجيله",
  "recordingStatuses.pending": "قيد الانتظار",
  "recordingStatuses.recording": "جارٍ التسجيل",
  "recordingStatuses.processing": "جارٍ تجهيز التسجيل",
  "recordingStatuses.failed": "فشل التسجيل",
  "recordingStatuses.expired": "منتهي الصلاحية",
  "recordingStatuses.unknown": "الحالة غير متاحة"
};
export function completeArabic(dictionary) {
 for (const [path,value] of Object.entries(arabicAdditions)) {
  const keys=path.split("."); let target=dictionary;
  for (const key of keys.slice(0,-1)) target=target[key] || (target[key]={});
  target[keys[keys.length-1]]=value;
 }
 return dictionary;
}
